import { Attachment } from '@/modules/Upload/types'
import datacentral from '@/utils/axios/datacentral'
import {
    ContractProcess,
    ContractProcessCreateParams,
    SubmitProcessResolveParams,
} from '../types'
import { ResponseArray } from '@/types/shared'

interface SubcontractParams {
    contractID: number
}
export const getContractProcesses = async ({
    contractID,
}: SubcontractParams) => {
    const response = await datacentral.get<ResponseArray<ContractProcess>>(
        `/contracts/customers/${contractID}/processes`
    )
    if (!response?.data?.results) return []
    return response?.data?.results
}

export interface ProcessCountResult {
    total: number
    by_status: {
        pending: number
        'in-progress': number
        completed: number
        cancelled: number
        rejected: number
    }
}

export const getContractProcessCount = async ({
    contractID,
}: SubcontractParams) => {
    const response = await datacentral.get<{ result: ProcessCountResult }>(
        `/contracts/customers/${contractID}/processes/count`
    )
    return response?.data?.result
}

export const createContractProcess = async ({
    contractID,
    data,
    attachments = [],
}: {
    contractID: number
    data: ContractProcessCreateParams
    attachments: Attachment[]
}) => {
    const response = await datacentral.post(
        `/contracts/customers/${contractID}/processes`,
        {
            contract: data,
            attachments,
        }
    )

    return response?.data?.result
}
export const createContractProcessHistory = async ({
    contractID,
    contractProcessID,
    data,
}: {
    contractID: number
    contractProcessID: number
    data: SubmitProcessResolveParams
}) => {
    const response = await datacentral.post(
        `/contracts/customers/${contractID}/processes/${contractProcessID}/histories`,
        {
            ...data,
        }
    )

    return response?.data?.result
}

export const cancelContractProcess = async ({
    contractID,
    contractProcessID,
}: {
    contractID: number
    contractProcessID: number
}) => {
    const response = await datacentral.delete(
        `/contracts/customers/${contractID}/processes/${contractProcessID}`
    )

    return response?.data?.result
}

export const getContractProcessHistories = async ({
    contractID,
    contractProcessID,
}: {
    contractID: number
    contractProcessID: number
}) => {
    const response = await datacentral.get(
        `/contracts/customers/${contractID}/processes/${contractProcessID}/histories`
    )

    return response?.data?.results || []
}

export const archiveContractProcess = async ({
    contractID,
    contractProcessID,
}: {
    contractID: number
    contractProcessID: number
}) => {
    const response = await datacentral.post(
        `/contracts/customers/${contractID}/processes/${contractProcessID}/archived`
    )

    return response?.data?.result
}

// upload pdf
export const scannerContract = async ({
    contractID,
    attachments,
    contract,
}: {
    contractID: number
    attachments: Attachment[]
    contract: { replace_old_attachment: boolean }
}) => {
    const response = await datacentral.post(
        `/contracts/customers/${contractID}/scanner`,
        {
            attachments,
            contract,
        }
    )

    return response?.data?.result
}
